import React, { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

const LogoutComplete = () => {
  const [searchParams] = useSearchParams()
  const [stage, setStage] = useState("checking")
  const [loginUrl, setLoginUrl] = useState("")

  const clearedParam = searchParams.get("cleared")

  useEffect(() => {
    localStorage.removeItem("email")
    localStorage.removeItem("user")
    localStorage.removeItem("tenantId")
    localStorage.removeItem("ssoIssuer")
    localStorage.removeItem("ssoClientId")
    localStorage.removeItem("tenantLoginUrl")

    const issuer = sessionStorage.getItem("logoutIssuer")
    const storedLoginUrl = sessionStorage.getItem("logoutLoginUrl")

    if (storedLoginUrl) {
      setLoginUrl(storedLoginUrl)
    }

    if (clearedParam || !issuer) {
      sessionStorage.removeItem("logoutIssuer")
      sessionStorage.removeItem("logoutLoginUrl")
      setStage("done")
      return
    }

    setStage("clearing")

    const returnUrl = `${window.location.origin}/logout-complete?cleared=true`

    let idpLogoutUrl = null

    if (issuer.includes('okta.com')) {
      idpLogoutUrl = `${issuer}/login/signout?fromURI=${encodeURIComponent(returnUrl)}`
    } else if (issuer.includes('login.microsoftonline.com')) {
      const baseUrl = issuer.replace('/v2.0', '')
      idpLogoutUrl = `${baseUrl}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(returnUrl)}`
    } else if (issuer.includes('auth0.com')) {
      idpLogoutUrl = `${issuer}/v2/logout?returnTo=${encodeURIComponent(returnUrl)}`
    } else if (issuer.includes('accounts.google.com')) {
      idpLogoutUrl = 'https://accounts.google.com/Logout'
    } else if (issuer.includes('pingidentity.com') || issuer.includes('.ping.')) {
      idpLogoutUrl = `${issuer}/idp/startSLO.ping`
    } else {
      idpLogoutUrl = `${issuer}/logout?post_logout_redirect_uri=${encodeURIComponent(returnUrl)}`
    }

    window.location.href = idpLogoutUrl

  }, [clearedParam])

  const handleLoginClick = () => {
    if (loginUrl) {
      window.location.href = loginUrl
    } else {
      window.location.href = "/"
    }
  }

  if (stage === "checking" || stage === "clearing") {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.spinner} />
          <p style={styles.loadingText}>Signing out...</p>
        </div>
        <style>{spinnerKeyframes}</style>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconContainer}>
          <svg
            style={styles.checkIcon}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 style={styles.title}>Successfully Logged Out</h1>

        <p style={styles.message}>
          You have been securely logged out of your account.
        </p>

        <button
          style={styles.button}
          onClick={handleLoginClick}
          onMouseOver={(e) => e.target.style.backgroundColor = '#d94d1e'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#F15A29'}
        >
          Login Again
        </button>
      </div>
    </div>
  )
}

const spinnerKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f7f7f7',
    fontFamily: "'Inter', 'Poppins', sans-serif",
    padding: '20px'
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%'
  },
  iconContainer: {
    width: '64px',
    height: '64px',
    backgroundColor: '#fef3ef',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto 24px'
  },
  checkIcon: {
    width: '32px',
    height: '32px',
    color: '#F15A29'
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#495057',
    margin: '0 0 12px'
  },
  message: {
    fontSize: '14px',
    color: '#74788d',
    margin: '0 0 32px',
    lineHeight: '1.5'
  },
  button: {
    backgroundColor: '#F15A29',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    width: '100%'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #F15A29',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto'
  },
  loadingText: {
    marginTop: '16px',
    color: '#74788d',
    fontSize: '14px'
  }
}

export default LogoutComplete
